import { BaseRequest } from '../../../soap/BaseRequest';

export interface IMoveProjectRequest {

}

export class MoveProjectRequest extends BaseRequest implements IMoveProjectRequest {
    public project_id: string;
    public target_folder_id: string;
    constructor(server: string, session: string, project_id: string, target_folder_id: string) {
        super(server, session);
        this.project_id = project_id;
        this.target_folder_id = target_folder_id;
    }

    public toQueryString(): string {
        let queryString = [];
        queryString.push(`instance=${this.server}`);
        queryString.push(`session=${this.session}`);
        queryString.push(`project_id=${this.project_id}`);  
        queryString.push(`target_folder_id=${this.target_folder_id}`);
        return queryString.join('&');
    }
}
